module.exports = __webpack_public_path__ + "static/cely_rose_bebe_2-f8c77004e6b23c39f78274be1fae6633.jpg";